<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <clipPath id="master_svg0_418_04565">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
    </defs>
    <g
      style="mix-blend-mode: passthrough"
      clip-path="url(#master_svg0_418_04565)"
    >
      <g style="opacity: 0; mix-blend-mode: passthrough"></g>
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,1C4.13438,1,1,4.13438,1,8C1,11.8656,4.13438,15,8,15C11.8656,15,15,11.8656,15,8C15,4.13438,11.8656,1,8,1ZM8,13.8125C4.79063,13.8125,2.1875,11.2094,2.1875,8C2.1875,4.79063,4.79063,2.1875,8,2.1875C11.2094,2.1875,13.8125,4.79063,13.8125,8C13.8125,11.2094,11.2094,13.8125,8,13.8125ZM8.50156,8.36719L10.72969,9.97812C10.78594,10.01719,10.79844,10.09531,10.75781,10.15312L10.31094,10.7625C10.27031,10.81719,10.19219,10.82969,10.13594,10.78906L7.55156,8.90469C7.51875,8.88125,7.5,8.84375,7.5,8.80312L7.5,4.5C7.5,4.43125,7.55625,4.375,7.625,4.375L8.37656,4.375C8.44531,4.375,8.50156,4.43125,8.50156,4.5L8.50156,8.36719Z"
          fill-rule="evenodd"
          fill="currentColor"
          fill-opacity="0.25"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallTime',
} as DefineComponent
</script>
